var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "d-flex align-center" },
        [
          _c("header-label", {
            attrs: { label: _vm.$t("crm.header"), "prepend-icon": "$crmHeader" }
          }),
          _c(
            "div",
            { staticClass: "mb-3" },
            [
              _c("v-icon", { attrs: { color: "primary" } }, [
                _vm._v(" mdi-chevron-left ")
              ])
            ],
            1
          ),
          _c("span", { staticClass: "primary--text mb-3" }, [
            _vm._v(" " + _vm._s(_vm.$t("shopsetting.header")) + " ")
          ])
        ],
        1
      ),
      _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { staticClass: "mb-3", attrs: { "no-gutters": "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "10" } },
                    [
                      _c("crm-toggle", {
                        staticClass: "mr-12",
                        attrs: {
                          text: _vm.$t("crm.enableCrm"),
                          state: _vm.state.enableCrm,
                          "text-icon": "$crmTitle"
                        },
                        on: {
                          input: function($event) {
                            return _vm.submit("enableCrm")
                          }
                        },
                        model: {
                          value: _vm.setting.enableCrm,
                          callback: function($$v) {
                            _vm.$set(_vm.setting, "enableCrm", $$v)
                          },
                          expression: "setting.enableCrm"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("p", { staticClass: "caption mb-0" }, [
                _vm._v(" " + _vm._s(_vm.$t("crm.hint1")) + " ")
              ]),
              _c("p", { staticClass: "caption mb-0" }, [
                _vm._v(" " + _vm._s(_vm.$t("crm.hint2")) + " ")
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }